HuesMdl.controller( 'BreadcrumbsCtrl', ['$scope', 'category', 'family', 'effect_fan', 'color_fan', 'HuesUpdaterSrv',
	function ( $scope, category, family, effect_fan, color_fan, HuesUpdaterSrv ) {


	var self = this,
	defaultValues = {
		family: 'כל משפחות הגוונים',
		color_fan: 'כל מניפות הגוונים',
		effect_fan: 'כל סוגי האפקטים'
	},
	breadcrumbs = [
		category.name,
		( family === false ) ? false : ( family === null ) ? defaultValues.family : family.name,
		( effect_fan === false ) ? false : ( effect_fan === null ) ? defaultValues.effect_fan : effect_fan.name,
		( color_fan === false ) ? false : ( color_fan === null ) ? defaultValues.color_fan : color_fan.name
	].filter( Boolean );

	this.breadcrumbs = breadcrumbs;

	$scope.$watch(function () { return HuesUpdaterSrv.isSearch;}, function( isSearch ){

		self.breadcrumbs = isSearch ? ['תוצאות חיפוש'] : breadcrumbs;

	});

	$scope.$watch(function () { return HuesUpdaterSrv.current_color;}, function( current_color ){

		self.current_color = current_color;

	});
}]);
